export default __webpack_public_path__ + "static/media/circle.5e941a07.svg";